<div class="header__breadcrumb">

  <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
    <a *ngIf="!breadcrumb.isLast" [routerLink]="[breadcrumb.url, breadcrumb.params]" class="header__breadcrumb__link">
            <i class="header__breadcrumb__icon" [ngClass]="null !== breadcrumb.icon ? 'ico-' + breadcrumb.icon : ''"></i><span>{{ breadcrumb.label }}</span>
        </a>
    <i *ngIf="i > 0" class="ico-angle-right header__breadcrumb__icon header__breadcrumb__icon--divider"></i>
    <span *ngIf="breadcrumb.isLast" class="header__breadcrumb__sub">
      <i *ngIf="null !== breadcrumb.icon" class="header__breadcrumb__icon ico-{{ breadcrumb.icon }}"></i>
      {{ breadcrumb.label }}</span>
  </ng-container>
</div>